import { put, takeLatest } from 'redux-saga/effects';

import { api, makeRequest } from 'shared/sdk';

const actionPrefix = 'Signup/';
const FETCH_VENDORS = `${actionPrefix}FETCH_VENDORS`;
const SUCCESS_FETCH_VENDORS = `${actionPrefix}SUCCESS_FETCH_VENDORS`;
const FAIL_FETCH_VENDORS = `${actionPrefix}FAIL_FETCH_VENDORS`;

export const fetchVendors = ({ filters = {} }) => ({
  type: FETCH_VENDORS,
  payload: {
    filters
  }
});

export const successFetchVendors = payload => ({
  type: SUCCESS_FETCH_VENDORS,
  payload
});

export const failFetchVendors = payload => ({
  type: FAIL_FETCH_VENDORS,
  payload
});

export const vendorsReducer = (newState, action) => {
  switch (action.type) {
    case SUCCESS_FETCH_VENDORS:
      newState['vendors'] = action.payload.results;
      break;

    default:
      return newState;
  }
};

function* fetchVendorsWorker(action) {
  const response = yield makeRequest(api.companiesList, {
    requestData: { params: action.payload.filters }
  });

  if (response.success) yield put(successFetchVendors(response.data));
  else yield put(failFetchVendors(response.errors));
}

export function* vendorsSaga() {
  yield takeLatest(FETCH_VENDORS, fetchVendorsWorker);
}
